const PROTOCOL_REGEXP = /^(http|https):\/\//;

const isCustomIcon = (icon) => icon && PROTOCOL_REGEXP.test(icon);

const getIconStyle = (icon) => (isCustomIcon(icon) && { 'mask-image': `url(${icon})` });

const getIconClass = (icon) => (isCustomIcon(icon) ? 'o-icon--custom' : `o-icon--${icon}`);

export { getIconStyle, getIconClass };
